import { useEffect, useState } from "react";
import { MMOAssetManager } from "../game";
import { useLoading } from "@utils/loading/useLoading";

interface AssetGuardProps {
  children: any;
}

export const AssetGuard = ({ children }: AssetGuardProps) => {
  const loadingManager = useLoading();
  const [assetsLoaded, setAssetsLoaded] = useState(false);

  useEffect(() => {
    const taskId = loadingManager.addTask({
      type: "progress",
      value: 0,
      max: 100,
      text: "Loading Assets",
    });

    const hasLoaded = MMOAssetManager.hasLoaded();
    setAssetsLoaded(hasLoaded);

    if (!hasLoaded) {
      MMOAssetManager.loadAssets(
        (state) => {
          loadingManager.updateTask(taskId, (task) => ({
            ...task,
            max: state.assetsToLoad,
            value: state.assetsLoaded,
            text: `${state.assetsLoaded} / ${state.assetsToLoad} assets loaded`,
          }));
        },
        () => {
          loadingManager.endTask(taskId);
          setAssetsLoaded(true);
        }
      );
      return;
    }
    loadingManager.endTask(taskId);
  }, [loadingManager]);

  if (assetsLoaded) {
    return children;
  }

  return null;
};
